import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-responsive-modal';
import { openReactModal } from '../actions';
import ErrorBoundary from '../components/ErrorBoundary';

const modalStyle = {
  overlay: {
    alignItems: 'center',
    zIndex: 10, // should appear above all page elements.
  },
  modal: {
    maxWidth: '100%',
    padding: '0px',
    borderRadius: 'var(--radius-24)',
    overflow: 'hidden',
  },
};

class EntrypointModal extends Component {
  render() {
    const { reactModalContent, onCloseReactModal, reactModalOnForceClose } =
      this.props;

    const modalOpen = !!reactModalContent;

    const reactModalClosed = () => {
      if (reactModalOnForceClose) {
        reactModalOnForceClose();
      }
      onCloseReactModal();
    };

    return (
      <ReactModal
        open={modalOpen}
        onClose={reactModalClosed}
        styles={modalStyle}
      >
        <ErrorBoundary key={!!modalOpen}>{reactModalContent}</ErrorBoundary>
      </ReactModal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reactModalContent: state.react_modal.content, // content to show in the react modal
    reactModalOnForceClose: state.react_modal.onForceClose, // optional handler to call when modal is close
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCloseReactModal: () => {
      dispatch(openReactModal(null));
    },
  };
};

// note: need to do 'connect' here, so that we have access to 'dispatch' in componentDidMount
export default connect(mapStateToProps, mapDispatchToProps)(EntrypointModal);
